import { defineStore } from "pinia";
import api from "@/api/api";

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    items: [],
    unread: 0,
    loaded: false,
  }),
  actions: {
    async fetch() {
      try {
        const { data } = await api.get("/api/notifications", { params: { per_page: 20 } });
        this.items = data?.data || [];
        this.unread = data?.unread ?? 0;
        this.loaded = true;
      } catch { /* keep current */ }
    },
    // Real-time insert from Pusher.
    prepend(notif) {
      if (!notif || this.items.some((n) => n.uuid === notif.uuid)) return;
      this.items.unshift(notif);
      if (!notif.read_at) this.unread += 1;
    },
    async markRead(uuid) {
      const n = this.items.find((x) => x.uuid === uuid);
      if (!n || n.read_at) return;
      n.read_at = new Date().toISOString();
      this.unread = Math.max(0, this.unread - 1);
      try { await api.post(`/api/notifications/${uuid}/read`); } catch { /* best-effort */ }
    },
    async markAllRead() {
      this.items.forEach((n) => { n.read_at = n.read_at || new Date().toISOString(); });
      this.unread = 0;
      try { await api.post("/api/notifications/read-all"); } catch { /* best-effort */ }
    },
    reset() {
      this.items = [];
      this.unread = 0;
      this.loaded = false;
    },
  },
});
